
import React, { useState, useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const ClientPortal = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginForm, setLoginForm] = useState({
    email: '',
    password: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLoginForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    // This is just a simple mock login
    if (loginForm.email && loginForm.password) {
      setIsLoggedIn(true);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Header */}
      <section className="pt-32 pb-20 bg-green-100 relative">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <span className="text-green-600 font-display uppercase tracking-wider text-sm mb-2 block animate-fade-up">
              Client Area
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-6 text-gray-900 animate-fade-up">
              Client Portal
            </h1>
            <p className="text-xl text-gray-700 animate-fade-up">
              Access your account information, view invoices, schedule services, and more.
            </p>
          </div>
        </div>
      </section>
      
      {/* Client Portal Content */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {isLoggedIn ? (
              <div className="bg-white p-8 shadow-md rounded-lg">
                <h2 className="text-3xl font-serif font-bold mb-6 text-gray-900">
                  Welcome Back!
                </h2>
                <p className="text-lg text-gray-700 mb-6">
                  You are now logged in to your client account.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="p-6 border border-gray-200 rounded-lg">
                    <h3 className="text-xl font-medium mb-3">My Services</h3>
                    <p className="text-gray-700">
                      View your current service plan and upcoming appointments.
                    </p>
                  </div>
                  
                  <div className="p-6 border border-gray-200 rounded-lg">
                    <h3 className="text-xl font-medium mb-3">Invoices</h3>
                    <p className="text-gray-700">
                      View and pay your invoices online.
                    </p>
                  </div>
                </div>
                
                <button 
                  onClick={() => setIsLoggedIn(false)}
                  className="mt-8 bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-700 transition-colors"
                >
                  Log Out
                </button>
              </div>
            ) : (
              <div className="bg-white p-8 shadow-md rounded-lg">
                <h2 className="text-3xl font-serif font-bold mb-6 text-gray-900">
                  Client Login
                </h2>
                <p className="text-lg text-gray-700 mb-8">
                  Log in to access your client account and manage your services.
                </p>
                
                <form onSubmit={handleLogin} className="max-w-md mx-auto">
                  <div className="mb-6">
                    <label htmlFor="email" className="block text-gray-700 mb-2">Email</label>
                    <input 
                      type="email" 
                      id="email" 
                      name="email"
                      value={loginForm.email}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md"
                      placeholder="Your Email"
                      required
                    />
                  </div>
                  
                  <div className="mb-6">
                    <label htmlFor="password" className="block text-gray-700 mb-2">Password</label>
                    <input 
                      type="password" 
                      id="password" 
                      name="password"
                      value={loginForm.password}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md"
                      placeholder="Your Password"
                      required
                    />
                  </div>
                  
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center">
                      <input 
                        type="checkbox" 
                        id="remember" 
                        className="mr-2"
                      />
                      <label htmlFor="remember" className="text-gray-700">Remember me</label>
                    </div>
                    
                    <a href="#" className="text-green-600 hover:text-green-700">Forgot password?</a>
                  </div>
                  
                  <button 
                    type="submit"
                    className="w-full bg-green-600 text-white px-6 py-3 rounded-md hover:bg-green-700 transition-colors"
                  >
                    Log In
                  </button>
                </form>
              </div>
            )}
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default ClientPortal;
